class CaseSelector extends HTMLElement {
  constructor() {
    super();

    const TabsContainer = this.querySelector('.js-case-picker-tabs');

    this.tabsWrapper = TabsContainer.querySelector('.case-picker__tabs');
    this.tabs = TabsContainer.querySelectorAll('.case-picker__tab');
    this.submenus = TabsContainer.querySelectorAll('.case-picker__submenu');
    this.triggers = this.querySelectorAll('[data-case-accordion-toggle]');

    this.overlay = document.createElement('div');
    this.overlay.className = 'cases__accordion-overlay';
    document.body.appendChild(this.overlay);

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.casePickerTabId;
        this.deactivateAll(this.tabs, 'tab');
        this.deactivateAll(this.submenus, 'submenu');
        this.activateById(this.tabs, 'tab', id);
        this.activateById(this.submenus, 'submenu', id);
        this.scrollTabIntoView();
      });
    });

    this.initAccordion();

    this.overlay.addEventListener('click', () => this.closeMobileAccordion());

    new ResizeObserver(() => {
      if (this.tabsWrapper) {
        this.tabsWrapper.style.setProperty('--scroll-width', `${this.tabsWrapper.scrollWidth}px`);
      }
    }).observe(TabsContainer);

    window.addEventListener('resize', () => {
      if (!this.isMobile && this.classList.contains('mobile-open')) {
        this.closeMobileAccordion();
      }
    });
  }

  get isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  initAccordion() {
    const selector = this.closest('.product__main-dropdowns')
      ? '.product__main [data-case-accordion-toggle]'
      : '.product__info-container [data-case-accordion-toggle]';

    this.triggers.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        if (this.isMobile) {
          this.openMobileAccordion(toggle);
          return;
        }

        this.querySelectorAll(selector).forEach((el) => {
          if (el !== toggle) {
            el.classList.remove('active');
            this.slide(el.nextElementSibling, false);
          }
        });

        if (toggle.classList.contains('active')) {
          toggle.classList.remove('active');
          this.slide(toggle.nextElementSibling, false);
        } else {
          toggle.classList.add('active');
          this.slide(toggle.nextElementSibling, true);
        }
      });
    });
  }

  openMobileAccordion(toggle) {
    if (toggle.classList.contains('active')) {
      this.closeMobileAccordion();
      return;
    }

    this.triggers.forEach((btn) => {
      if (btn !== toggle) btn.classList.remove('active');
    });
    this.querySelectorAll('[data-case-accordion-toggle] + *').forEach((panel) => {
      if (panel !== toggle.nextElementSibling) this.slide(panel, false);
    });

    toggle.classList.add('active');
    this.slide(toggle.nextElementSibling, true);

    document.body.classList.add('overflow-hidden-drawer');
    this.overlay.classList.add('active');
    this.classList.add('mobile-open');
  }

  closeMobileAccordion() {
    this.triggers.forEach((toggle) => toggle.classList.remove('active'));
    this.querySelectorAll('[data-case-accordion-toggle] + *').forEach((panel) => {
      this.slide(panel, false);
    });
    document.body.classList.remove('overflow-hidden-drawer');
    this.overlay.classList.remove('active');
    this.classList.remove('mobile-open');
  }

  deactivateAll(elements, type) {
    elements.forEach((el) => el.classList.remove(`case-picker__${type}--active`));
  }

  activateById(elements, type, id) {
    elements.forEach((el) => {
      if (el.dataset.casePickerTabId === id) el.classList.add(`case-picker__${type}--active`);
    });
  }

  scrollTabIntoView() {
    const active = this.querySelector('.case-picker__tab--active');
    if (!active) return;

    const wrapperRect = this.tabsWrapper.getBoundingClientRect(),
      tabRect = active.getBoundingClientRect();

    if (tabRect.left < wrapperRect.left) {
      this.tabsWrapper.scrollLeft += tabRect.left - wrapperRect.left;
    } else if (tabRect.right > wrapperRect.right) {
      this.tabsWrapper.scrollLeft += tabRect.right - wrapperRect.right;
    }
  }

  slide(element, open, duration = 300) {
    if (!element) return;
    if (open) {
      element.style.display = 'block';
      const height = element.scrollHeight;
      element.style.overflow = 'hidden';
      element.style.height = '0';
      requestAnimationFrame(() => {
        element.style.transition = `height ${duration}ms ease`;
        element.style.height = height + 'px';
      });
      setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('transition');
        element.style.removeProperty('overflow');
      }, duration);
    } else {
      element.style.height = element.scrollHeight + 'px';
      element.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        element.style.transition = `height ${duration}ms ease`;
        element.style.height = '0';
      });
      setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('transition');
        element.style.removeProperty('overflow');
      }, duration);
    }
  }
}

customElements.define('case-selector', CaseSelector);
